import { Component, inject, input } from '@angular/core';
import { DashboardBanner } from '../../../../data-access/models/dashboard-parts.model';
import { EIntrackEventName } from '../../../../components/core/models/intrack-event-name.enum';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { CROWD_LIST_ROUTE } from '../../../../data-access/constants/app-routes';
import { NgxCarouselComponent, NgxCarouselSlideDirective } from '@digipay/ngx-carousel';
import { NgxEventTrackerService } from '@digipay/ngx-event-tracker';

@Component({
  selector: 'wealth-applet-home-banner',
  standalone: true,
  imports: [NgxCarouselComponent, NgxCarouselSlideDirective, NgxCarouselComponent],
  templateUrl: './home-banner.component.html',
  styleUrl: './home-banner.component.scss',
})
export class HomeBannerComponent {
  banners = input<DashboardBanner[]>();
  private navigationService = inject(WealthNavigationService);
  private eventService = inject(NgxEventTrackerService);

  openInvestments(banner: DashboardBanner) {
    const eventData = {
      eventName: EIntrackEventName.ASSET_CLASS_SELECT,
      eventData: {
        TYPE: banner.queryParams ?? 'Direct',
        ID: banner.bannerId,
      },
    };
    this.eventService.sendEvent(eventData);
    if (banner.title === 'CROWD') {
      this.navigationService.navigate([CROWD_LIST_ROUTE]);
    } else {
      if (banner.bannerId) {
        if (banner.bannerId === 'treasury') {
          this.navigationService.navigate([banner.path, banner.bannerId], {
            queryParams: {
              referrer: 'wealth',
            },
          });
        } else {
          this.navigationService.navigate([banner.path, banner.bannerId]);
        }
      } else {
        this.navigationService.navigate([banner.path], {
          queryParams: { type: banner.queryParams },
        });
      }
    }
  }
}
